import React, { useState } from 'react';
import { TargetIcon } from './Icons';
import styles from '../styles/ContentCard.module.css';

/**
 * Testimonial Card Component
 * Displays user testimonial/success story cards with optional user image
 *
 * Props:
 * - userName: Name of the user giving testimonial
 * - achievement: What they achieved
 * - testimonialText: The testimonial text
 * - imageUrl: Optional user photo/avatar URL
 * - date: Optional date of testimonial
 */
function TestimonialCard({ userName, achievement, testimonialText, imageUrl, date }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(true);
  };

  // Generate initials for avatar fallback
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  return (
    <div className={styles.contentCard}>
      <div className={styles.contentCardHeader}>
        Success Story
      </div>

      <div className={styles.contentCardContent}>
        {/* User header with avatar */}
        <div className={styles.testimonialHeader}>
          <div className={styles.avatarContainer}>
            {imageUrl && !imageError ? (
              <>
                {!imageLoaded && (
                  <div className={styles.avatarPlaceholder}>
                    <div className={styles.avatarLoader}></div>
                  </div>
                )}
                <img
                  src={imageUrl}
                  alt={userName}
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                  style={{ display: imageLoaded ? 'block' : 'none' }}
                  className={styles.avatar}
                />
              </>
            ) : (
              <div className={styles.avatarFallback}>
                {getInitials(userName)}
              </div>
            )}
          </div>
          <div className={styles.testimonialUserInfo}>
            <div className={styles.userName}>{userName}</div>
            {achievement && (
              <div className={styles.achievement}>
                <TargetIcon size={16} /> {achievement}
              </div>
            )}
          </div>
        </div>

        {/* Testimonial text */}
        {testimonialText && (
          <div className={styles.testimonialText}>
            "{testimonialText}"
          </div>
        )}

        {date && (
          <div className={styles.contentCardMeta}>
            <div className={styles.contentCardMetaItem}>
              {new Date(date).toLocaleDateString()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TestimonialCard;
